import React from 'react';
import { worldviews } from '../../onboardingContent';
import { logEvent } from '../../lib/analytics';

export default function WorldviewPicker({ onSelect }) {
  const handleSelect = (key) => {
    logEvent('select_worldview', { worldview: key });
    onSelect(key);
  };

  return (
    <div className="container mx-auto mt-8">
      <h2 className="mb-6 text-center text-2xl font-semibold">
        Choose your starting point
      </h2>
      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
        {worldviews.map((w) => (
          <button
            key={w.key}
            type="button"
            onClick={() => handleSelect(w.key)}
            className={[
              'rounded-lg border border-gray-200 bg-cream p-6 text-center text-lg font-medium text-olive shadow-sm transition-all',
              'hover:-translate-y-1 hover:border-wheat hover:bg-wheat/10 hover:shadow-md',
              'focus:outline-none focus:ring-2 focus:ring-wheat'
            ].join(' ')}
          >
            {w.label}
          </button>
        ))}
      </div>
    </div>
  );
}
